			<!-- Header -->
            <header id="header">
                <h1 id="logo"><a href="/">Five ASide Theatre CIC</a><img src="./assets/images/logo-small.png" alt="" /></h1>
                <nav id="nav">
                    <ul>
                        <li>
                            <a href="/home">Theatre</a>
                            <ul>
                                <li>
                                    <a href="#one" class="scrolly">Dorothee in the 18th century</a>
                                </li>
                                <li>
                                    <a href="#two" class="scrolly">Samuel Mudian</a>
                                </li>
                                <li>
                                    <a href="#five" class="scrolly">John</a>
                                </li>                                
                                <li>
                                    <a href="#four" class="scrolly">Samuel Linley</a>
                                </li>                                
                                <li>
                                    <a href="#three" class="scrolly">Charles Caesar</a>
                                </li>
                                <li>
                                    <a href="#six" class="scrolly">Thomas</a>
                                </li>
                                <!--
                                <li>
                                    <a href="#seven" class="scrolly">Dorothee Revisualised</a>
                                </li>
                            -->
                                <li>
                                    <a href="#getdirections" class="scrolly">Get Directions</a>
                                </li>
                            </ul>
                        </li>
                        <li><a href="/trainer">Trainer</a></li>
                        <li>
                            <a href="/themes">Themes</a>                         
                        </li>
                        <li><a href="/tournament">Tournament</a>
                        
                            <ul>
                                <li>
                                    <a href="/tournament#info" class="scrolly">Tournament Information </a>
                                </li>
                                <li>
                                    <a href="/tournament#faq" class="scrolly">FAQs</a>
                                </li>
                                <li>
                                    <a href="/tournament#application" class="scrolly">Book onto our Tournament</a>
                                </li>
                                <li>
                                    <a href="/tournament#schedule" class="scrolly">Winter Schedule </a>
                                </li>
                                <li>
                                    <a href="/tournament#feedback" class="scrolly">Feedback </a>
                                </li>
                            </ul>                        

                        </li>
                        <li><a href="/the-peoples-writes">The People's Writes</a>
                            <ul>
                                <li>
                                    <a href="/the-peoples-writes#dorothee18" class="scrolly">Dorothee 18th</a>
                                </li>
                                <li>
                                    <a href="/the-peoples-writes#dorothee20" class="scrolly">Dorothee 20th</a>
                                </li>                              
                            </ul>
                        </li>
                        <li><a href="/aboutus">About Us</a>
                        </li>
                        
                        <!--
                        <li><a href="index.html">Home</a></li>
                        <li>
                            <a href="#">Layouts</a>
                            <ul>
                                <li><a href="left-sidebar.html">Left Sidebar</a></li>
                                <li><a href="right-sidebar.html">Right Sidebar</a></li>
                                <li><a href="no-sidebar.html">No Sidebar</a></li>
                                <li>
                                    <a href="#">Submenu</a>
                                    <ul>
                                        <li><a href="#">Option 1</a></li>
                                        <li><a href="#">Option 2</a></li>
                                        <li><a href="#">Option 3</a></li>
                                        <li><a href="#">Option 4</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li><a href="elements.html">Elements</a></li>
                        -->
                        <li><a href="#" class="button primary">Sign Up</a></li>
                    </ul>
                </nav>
            </header>
